import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Option } from 'types/types';

type MapperFn<T> = (item: T) => Option;

interface UseOptionsParams<T> {
  queryKey: unknown[];
  fetchFn: () => Promise<T[]>;
  mapperFn?: MapperFn<T>;
  options?: Omit<UseQueryOptions<Option[], Error>, 'queryKey' | 'queryFn'>;
}

export function useOptions<T>({ queryKey, fetchFn, mapperFn, options }: UseOptionsParams<T>) {
  return useQuery<Option[], Error>({
    queryKey,
    queryFn: async () => {
      const data = await fetchFn();
      return data.map(
        mapperFn ??
          ((item: any) => ({
            value: item.id,
            label: item.name,
          }))
      );
    },
    staleTime: 5 * 60 * 1000, // 5 min caching
    ...options,
  });
}
